import Row from "react-bootstrap/Row";
import React, {useEffect, useMemo, useState} from "react";
import Col from "react-bootstrap/Col";
import {getIn} from 'formik'
import Box from "../../ui/box/Box";
import {AccessoryForm} from "./AccessoryForm";
import useFetch from "../../../hooks/useFetch";
import AccessoryAPI from "../../../services/AccessoryAPI";
import Checkbox from "../../ui/form/Checkbox";
import Field from "../../ui/form/Field";
import {OrderFormInterface} from "./OrderFormInterface";
import {
    BUBBLE_PRICE,
    RIBBON_MAX_LENGTH,
    RIBBON_PRICE,
} from '../../../constants/Constants'

interface AccessoriesFormInterface extends OrderFormInterface {
    order: Object,
}

export const AccessoriesForm = ({formik, colXs, colSm, order}: AccessoriesFormInterface) => {
    const [{data: accessories}] = useFetch(AccessoryAPI.getAccessories());
    const isMourningEvent = useMemo(() => formik.values.occasion === 5 || formik.values.occasion === '5', [formik.values.occasion]);
    const [ribonValueLengthMax] = useState(RIBBON_MAX_LENGTH);
    const [ribonValueLength, setRibonValueLength] = useState(0);

    function onCheckBubble(event) {
        formik.setFieldValue('bubble', event.target.checked)
    }

    useEffect(() => {
        if (formik.values.occasion === 5 || formik.values.occasion === '5') {
            formik.setFieldValue('accessories', []);
            formik.setFieldValue('bubble', false);
        }
    }, [formik.values.occasion]);

    // Sélection des bons accessoires dans le cas de la modification d'une commande en attente (senattente)
    useEffect(() => {
        if (order?.accessories && order.accessories.length > 0) {
            const orderAccessoriesMap = formik.values.accessoriesMap;
            order.accessories.forEach((accessoryMap) => {
                const accessoriesMapKey = accessories.map(value => value.id).indexOf(accessoryMap.item_id); // Récupère l'index

                if (accessoriesMapKey >= 0) {
                    orderAccessoriesMap.set(accessoriesMapKey, accessoryMap);
                }
            })
        }
    }, [order, accessories]);

    useEffect(() => {
        if (isMourningEvent) {
            formik.setFieldValue('accessoriesMap', new Map());
        }
    }, [isMourningEvent]);

    useEffect(() => {
        setRibonValueLength(formik.values.ruban ? formik.values.ruban.length : 0);
    }, [formik.values.ruban])

    return (
        <Box
            boxXs={colXs}
            boxSm={colSm}
            boxName={'accessories'}
            headerClassNames={'rounded-top'}
            header={true}
            headerContent={<h3 className="my-auto">Accessoires</h3>}
            headerPadding={'p-3'}
            boxContentPadding={'p-3'}
            content={
                <>
                    <Row className={'mb-2'}>
                        <Col sm={12} md={5}>
                            <Checkbox
                                id={'bubble'}
                                name={'bubble'}
                                type={'checkbox'}
                                aria-label={`Avec bulle d'eau ${BUBBLE_PRICE} €`}
                                label={`Avec bulle d'eau ${BUBBLE_PRICE} €`}
                                className={'mb-2'}
                                checked={formik.values.bubble}
                                onChange={(event) => onCheckBubble(event)}
                            />
                        </Col>
                        {formik.values.numberOfAccessories >= 3 && (
                            <Col
                                sm={12}
                                md={7}
                                className={'d-flex justify-content-end'}>
                                <strong className={'text-danger'}>
                                    {' '}
                                    Le nombre maximal d'accessoires par commande
                                    est de 3
                                </strong>
                            </Col>
                        )}
                    </Row>

                    {(formik.values.occasion === 5 ||
                        formik.values.occasion === '5') && (
                        <Row className={'mb-2'}>
                            <Col sm={12}>
                                <Checkbox
                                    id={'ruban'}
                                    name={'ruban'}
                                    label={`Ruban ${RIBBON_PRICE} €`}
                                    checked={formik.values.hasRibbon}
                                    classNames={'font-weight-bold'}
                                    fieldClassNames={'border'}
                                    onChange={(event) =>
                                        formik.setFieldValue(
                                            'hasRibbon',
                                            event.target.checked,
                                        )
                                    }
                                />
                                {formik.values.hasRibbon && (
                                    <Field
                                        id={'ruban'}
                                        name={'ruban'}
                                        label={'message ruban'}
                                        placeholder={'message ruban'}
                                        labelRequired={true}
                                        value={formik.values.ruban}
                                        classNames={'mt-1 required'}
                                        fieldClassNames={'mb-0'}
                                        onChange={formik.handleChange}
                                        maxLength={ribonValueLengthMax}
                                        error={
                                            getIn(formik.touched, 'ruban') &&
                                            getIn(formik.errors, 'ruban')
                                        }
                                        helpContent={`${ribonValueLengthMax - ribonValueLength}/${ribonValueLengthMax}`}
                                    />
                                )}
                            </Col>
                        </Row>
                    )}
                    <Row className={'mt-4'}>
                        {accessories.length > 0 &&
                            accessories.map((accessory, index) => (
                                <AccessoryForm
                                    key={accessory.id}
                                    index={index}
                                    accessory={accessory}
                                    formik={formik}
                                />
                            ))}
                    </Row>
                </>
            }
        />
    )
}
